function mergeParams(e = {}) {
	const { scene= '', ...other } = e;
	const query = decodeURIComponent(scene).split('&').reduce((previous,item) => {
		const [ key, value ] = item.split('=');
		if (key) {
			previous[key] = value;
		}
		return previous
	}, {});
	return {...other, ...query};
}

function mergeAppParams(e = {}) {
	const { query={}, scene } = e;
	const { scene: sceneStr, ...other } = query;
	const sceneQuery = decodeURIComponent(sceneStr || '').split('&').reduce((previous,item) => {
		const [ key, value ] = item.split('=');
		if (key) {
			previous[key] = value;
		}
		return previous
	}, {});
	return {...other, ...sceneQuery, scene};
}

function formatTime(date,str = '/') {

  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join(str) + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/**
 * @param {string} url
 * @returns {Object}
 */
const param2Obj = function(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

const getRandom = function(min, max) {
    return min + Math.floor(Math.random() * (max - min + 1))
}

function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
}
function padLeftZero(str) {
  return ("00" + str).substr(str.length);
}

function getUrlKey (name) {
  console.log(name, "name====>")
  return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(decodeURIComponent(location.href))||[,""])[1].replace(/\+/g,'%20'))||null;
}

module.exports = {  
 mergeParams,
 mergeAppParams,
 formatTime,
 param2Obj,
 getRandom,
 formatDate,
 getUrlKey
}